/**
 * @generated SignedSource<<cfc87a8e3888f98b790325fd6e6e58c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnitSchoolYearEnum = "elementary_school_3" | "elementary_school_4" | "elementary_school_5" | "elementary_school_6" | "high_school_1_2015" | "high_school_1_2022" | "high_school_2_2015" | "high_school_2_daesu_2022" | "high_school_2_mijukbun_2022" | "high_school_3_hwaktong_2022" | "high_school_3_liberal_arts_2015" | "high_school_3_mijukbun2_giha_2022" | "high_school_3_science_2015" | "middle_school_1" | "middle_school_2" | "middle_school_3" | "%future added value";
export type UnitSchoolYearSelectField_unitQuery$variables = {
  id: string;
};
export type UnitSchoolYearSelectField_unitQuery$data = {
  readonly unit: {
    readonly id: string;
    readonly schoolYears: ReadonlyArray<UnitSchoolYearEnum>;
  };
};
export type UnitSchoolYearSelectField_unitQuery = {
  response: UnitSchoolYearSelectField_unitQuery$data;
  variables: UnitSchoolYearSelectField_unitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Unit",
    "kind": "LinkedField",
    "name": "unit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolYears",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitSchoolYearSelectField_unitQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitSchoolYearSelectField_unitQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8ddac2bc52f3cbed801fd0df89d43dae",
    "id": null,
    "metadata": {},
    "name": "UnitSchoolYearSelectField_unitQuery",
    "operationKind": "query",
    "text": "query UnitSchoolYearSelectField_unitQuery(\n  $id: ID!\n) {\n  unit(id: $id) {\n    id\n    schoolYears\n  }\n}\n"
  }
};
})();

(node as any).hash = "1dbba7fd7a515de9537cc7608a6b5394";

export default node;
